//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//contact_type
import ContactTypeIndex from '../views/contact_type/Index.vue';
import ContactTypeList from '../views/contact_type/List.vue';
import ContactTypeForm from '../views/contact_type/Form.vue';
//client
import ClientIndex from '../views/client/Index.vue';
import ClientList from '../views/client/List.vue';
import ClientForm from '../views/client/Form.vue';
//contract
import ContractIndex from '../views/contract/Index.vue';
import ContractList from '../views/contract/List.vue';
import ContractForm from '../views/contract/Form.vue';
//contact
import ContactIndex from '../views/contact/Index.vue';
import ContactList from '../views/contact/List.vue';
import ContactForm from '../views/contact/Form.vue';
//report
import ReportIndex from '../views/report/Index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/contact_type',
    component: ContactTypeIndex,
    children: [
      {
        path: "/",
        component: ContactTypeList
      },
      {
        path: ":id",
        component: ContactTypeForm
      }
    ]
  },
  {
    path: '/client',
    component: ClientIndex,
    children: [
      {
        path: "/",
        component: ClientList
      },
      {
        path: ":id",
        component: ClientForm
      }
    ]
  },
  {
    path: '/contract',
    component: ContractIndex,
    children: [
      {
        path: "/",
        component: ContractList
      },
      {
        path: ":id",
        component: ContractForm
      }
    ]
  },
  {
    path: '/contact',
    component: ContactIndex,
    children: [
      {
        path: "/",
        component: ContactList
      },
      {
        path: ":id",
        component: ContactForm
      }
    ]
  },
  {
    path: '/report',
    component: ReportIndex
  }
];

const router = new VueRouter({
  routes
});

export default router;